var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("DisplayChangeByPrevPageTypeAddMembershipAppeal", {
        attrs: { "prev-page-type": _vm.prevPageType },
      }),
      _vm._v(" "),
      _c(
        "section",
        { staticClass: "outerOfMemberContent" },
        [
          _vm.prevPageType.isOc()
            ? _c("p", { staticClass: "announceForAlreadyMember" }, [
                _vm._v("すでに会員登録済みの方はこちら"),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("PageTop", { staticClass: "pageTopComponent" }),
          _vm._v(" "),
          _c("p", { staticClass: "loginAnnounce" }, [
            _vm._v("ログインにはスタディサプリ共通のIDを利用できます。"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "loginAnnounceGroup" }, [
            _vm._v(
              "※在籍校で利用している団体利用アカウントの場合はログインできません"
            ),
          ]),
          _vm._v(" "),
          _c("ServiceLogoList", { staticClass: "logos" }),
          _vm._v(" "),
          _c("InputWithLabel", {
            attrs: {
              "area-label": "ユーザー名またはメールアドレス",
              "input-type": "text",
              placeholder: "ユーザー名、メールアドレスを入力",
              maxlength: "161",
              "validation-list": [
                _vm.VALIDATION_LIST.EMPTY,
                _vm.VALIDATION_LIST.USER_NAME_AND_EMAIL,
              ],
            },
            on: { watchValidation: _vm.watchUserNameValidation },
            model: {
              value: _vm.handleUserName,
              callback: function ($$v) {
                _vm.handleUserName = $$v
              },
              expression: "handleUserName",
            },
          }),
          _vm._v(" "),
          _c("Password", {
            staticClass: "inputArea",
            attrs: {
              "area-label": "パスワード",
              placeholder: "パスワードを入力",
              "right-space": "",
              maxlength: "72",
            },
            on: { watchValidation: _vm.watchPasswordValidation },
            model: {
              value: _vm.handlePassword,
              callback: function ($$v) {
                _vm.handlePassword = $$v
              },
              expression: "handlePassword",
            },
          }),
          _vm._v(" "),
          _c("ErrorMessage", {
            staticClass: "errorMessageComponent",
            attrs: {
              "error-message-list": _vm.serverErrorList,
              "result-code": _vm.resultCode,
            },
          }),
          _vm._v(" "),
          _c("CheckboxArea", {
            staticClass: "checkboxComponent",
            model: {
              value: _vm.staySignInFlag,
              callback: function ($$v) {
                _vm.staySignInFlag = $$v
              },
              expression: "staySignInFlag",
            },
          }),
          _vm._v(" "),
          _c("TermsAndPolicy", { staticClass: "termsAndPolicyComponent" }),
          _vm._v(" "),
          _c("ButtonTypeCustom", {
            staticClass: "loginButton",
            class: { "is-disabled": !_vm.canSendRequest },
            attrs: {
              "button-type": "button",
              "button-text": "上記に同意してログインする",
              "button-color": "colorPrimary",
              "button-size": "sizeLarge",
              "max-width-none": "",
            },
            on: { "button-clicked": _vm.login },
          }),
          _vm._v(" "),
          _c("ResolutionLostInfo", {
            attrs: {
              "lost-user-id-url": "/rnet/info/61.html",
              "lost-user-id-text": "ユーザー名がわからない場合",
              "lost-password-url": "/rnet/info/60.html",
              "lost-password-text": "パスワードがわからない場合",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }